export function makeShort3() {
    $(this).toggleClass("hover").delay(200);
}

